import { JSX } from 'react'

import { Box, HStack, Image, Heading, Text } from '@chakra-ui/react'

import logo from '/public/images/logo.png'

import i_x_001 from '/public/images/authorize/i.x.001@2x.png'



export default function (): JSX.Element
{
	return (
		<Box h="100%" p="24">
			<HStack gap="8">
				<Image
					p="2"
					boxSize="14"
					bg="white"
					fit="cover"
					rounded="2xl"
					boxSizing="content-box"
					src={logo}
				/>

				<Heading size="4xl" color="white">蓝色海棠员工管理平台</Heading>
			</HStack>

			<Box mt="12">
				<Text color="white" fontSize="6xl">Your place to work</Text>
				<Text color="white" fontSize="6xl" fontWeight="medium">Plan. Create. Control.</Text>
			</Box>

			<Image src={i_x_001} mt="12" height="3/5" />

		</Box>
	)

}
